import { formatDateLocal } from "../../../../../lib/script";
import Button from "../../../../common/Button";
import classes from './FutureAppointmentItem.module.css';
import { notificationActions } from "../../../../../store/notifications";
import { caseQuickUpdate } from "../../../../../lib/fetchApi";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

export default function FutureAppointmentItem({appointment, itemData, apiCase, closeModal}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const [loading, setLoading] = useState(false)

    const selectAppointmentHandler = async () => {
        setLoading(true)
        try {
            let reqBody = {
                type: apiCase,
                type_id: itemData.id,
                fields: {
                    step_7_appointment_id: appointment.id,
                    step_7_scheduled_date: appointment.date
                }
            }

            let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)
            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {            
                if (closeModal) {
                    closeModal()
                }
            }
        } finally {
            setLoading(false)
        }
    }

    return <div className={classes.item}>
        <div>{formatDateLocal(appointment.date)} - <strong>{appointment.event?.name}</strong></div>
        <div><Button btnStyle='btn_small' click={selectAppointmentHandler} isLoading={loading} >Select</Button></div>
    </div>
}